import { AfterViewInit, Component, Injector, OnInit } from '@angular/core';
import { MonitoringService } from '@app/shared/common/telemetry-implementation/MonitoringService ';
import { AppComponentBase } from '../../../../../shared/common/app-component-base';
import { AllDashboardServiceProxy, DashboardUserDto } from '../../../../../shared/service-proxies/service-proxies';

@Component({
    selector: 'app-new-joinee-section',
    templateUrl: './new-joinee-section.component.html',
    styleUrls: ['./new-joinee-section.component.css']
})
export class NewJoineeSectionComponent extends AppComponentBase implements OnInit, AfterViewInit{

    newJoineInfo: DashboardUserDto[];
    isLoaded = false;
    isempty = true;
    dateTime = new Date();
    istrueValue: boolean;
    constructor(private _monitorService:MonitoringService,private _AllDashboardServiceProxy: AllDashboardServiceProxy, injector: Injector) {super(injector) }

    ngOnInit(): void {
    }

    ngAfterViewInit() {
        this.getNewJoineesInfo();
    }


    getNewJoineesInfo() {
        try{
        this._monitorService.logTrace("UI-getNewJoineesInfo",{"getNewJoineesInfo ":"start: "+this+this.dateTime})
        this.istrueValue = this.isGranted('Pages.ShowManager.Dashboard');
        this._AllDashboardServiceProxy.getNewJoiner(this.istrueValue).subscribe(result => {
            this.newJoineInfo = [];
            result = result.filter(x => x.usersRole );
            result.forEach(x => {
                    if (x.userImage === '' || x.userImage === 'undefined' || x.userImage === null) {
                        x.userImage = 'assets/common/images/default-profile-picture1.svg';
                    }
                this.newJoineInfo.push(x);
                this.isempty = false;
            });
            this.isLoaded = true;
            result.forEach(x=>{
                x.usersRole = x.usersRole.map(x=> this.l(x));
            })
        })
    }
    catch(ex:any){
        this._monitorService.logException(ex ,2);
      }
    }



    DisableTooltip(name: string, num: number) {
        return name?.length > num ? false : true;
    }
}
